import { Component } from '@angular/core';
import { BaryModalEvent, IBaryModalEvent } from '../../../../../../models/bary-modal-event';
import { MDBModalRef } from 'ng-uikit-pro-standard';
import { BaryComponentHelper } from '../../../../util/bary-component-helper';

@Component({
  selector: 'jhi-modal-change-order',
  templateUrl: './modal-change-order.component.html',
  styleUrls: ['./modal-change-order.component.scss'],
})
export class ModalChangeOrderComponent {
  model!: any[];
  action = BaryComponentHelper.generateAction<IBaryModalEvent>();
  labelField = 'id';

  constructor(public modalRef: MDBModalRef) {}

  handleClick(from: any): void {
    this.action.next(new BaryModalEvent(from));
    this.modalRef.hide();
  }

  handleSubmit(): void {
    this.action.next(new BaryModalEvent({ submit: true, value: this.model }));
    this.modalRef.hide();
  }
}
